import React from 'react';
import { useIntl } from 'react-intl';

import {
  AttendeeState,
  City,
  EventForCompactEventCard,
} from 'app/shared/typings';
import { Spinner } from 'app/shared/components/atoms';
import { Box } from 'app/shared/components/atoms';
import { ActionButton } from 'app/shared/components/molecules';

import { CompactEventCard } from './CompactEventCard';

interface Props {
  events?: EventForCompactEventCard[];
  city?: City;
  dataQaidPrefix: string;
  totalEventsCount: number;
  eventsLoading: boolean;
  userAttendeeStatesByEventId: { [eventID: string]: AttendeeState };
  trackEventClicked: (event: EventForCompactEventCard, index: number) => void;
  fetchMoreEvents: () => void;
  showAllEvents?: boolean;
}

export const EventList: React.FC<React.PropsWithChildren<Props>> = ({
  events = [],
  city,
  dataQaidPrefix,
  totalEventsCount,
  eventsLoading,
  userAttendeeStatesByEventId,
  trackEventClicked,
  fetchMoreEvents,
  showAllEvents,
  children,
}) => {
  const { formatMessage } = useIntl();

  return (
    <Box
      gap={8}
      flexDirection="column"
      data-qaid={`${dataQaidPrefix}-event-list`}
    >
      <Box gap={4} w="100%" flex={1} flexDirection="column">
        {events.map((event, index) => (
          <Box
            key={event.id}
            data-qaid={`${dataQaidPrefix}-event-card-${index}`}
          >
            <CompactEventCard
              event={event}
              city={city}
              userAttendeeState={userAttendeeStatesByEventId[event.id]}
              data-qaid={`${dataQaidPrefix}-event-card-link`}
              onClick={() => trackEventClicked(event, index)}
            />
          </Box>
        ))}
      </Box>
      {eventsLoading && (
        <Box justifyContent="center" alignItems="center" p={4}>
          <Spinner />
        </Box>
      )}
      {totalEventsCount > (events.length || 0) &&
        !eventsLoading &&
        !showAllEvents && (
          <Box w="100%" flex={1} flex-direction="row" justifyContent="center">
            <ActionButton
              fullWidth
              onClick={fetchMoreEvents}
              data-qaid={`${dataQaidPrefix}-show-more-concerts`}
              variant="tertiary"
            >
              {formatMessage({ id: 'shared.showMoreConcerts' })}
            </ActionButton>
          </Box>
        )}
      {children}
    </Box>
  );
};
